export default {
  paused: 'Płatności online są wstrzymane z powodu problemów z weryfikacją KYC.',
  deadline_warning: 'Wymagana jest weryfikacja KYC, w przeciwnym razie płatności online zostaną wstrzymane {{date}}.',
  complete_verification: 'Zakończ weryfikację',
  partner: {
    action_needed:
      'Twój dostawca płatności potrzebuje jeszcze jednej rzeczy, zanim ta restauracja będzie mogła przyjmować płatności online.',
    hosted_incomplete: 'Nie ukończono jeszcze konfiguracji płatności online u dostawcy płatności.',
    link_expired: 'Twój link do dokończenia konfiguracji płatności online wygasł. Pobierz nowy i kontynuuj.',
    open_error: 'Nie można połączyć się z dostawcą płatności. Spróbuj ponownie za kilka minut.',
    hosted_not_started: 'Płatności online nie zostały jeszcze skonfigurowane u dostawcy płatności.',
    business_details_missing: 'Dodaj dane firmy, aby rozpocząć przyjmowanie płatności online.',
    continue: 'Kontynuuj',
  },
};
